import React, { useEffect } from "react";
import StudentSignup3 from "../StudentSignUp/StudentSignup3";
import PropTypes from "prop-types";

const MentorSignUp3 = (props) => {

  const { title } = props;
  useEffect(() => {
    document.title = title;
  }, [title]);


  return (
    <StudentSignup3 />
  );
};
MentorSignUp3.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MentorSignUp3;
